// Cache bust marker: 1779247619
(function(){
  var GIFT_VARIANT = '51556557226282';
  var GIFT_HANDLE  = 'handwritten-gift-note';
  var UPSELL_MAX = 3;
  var UPSELL_CACHE = {};

  function $(sel, root){ return (root || document).querySelector(sel); }

  function setMsg(el, text, cls){
    if (!el) return;
    el.className = 'cp-cart__addon__msg' + (cls ? ' ' + cls : '');
    el.textContent = text || '';
  }

  function refreshDrawer(){
    if (window.MinimogTheme && window.MinimogTheme.Cart && typeof window.MinimogTheme.Cart.refreshCart === 'function') {
      try { window.MinimogTheme.Cart.refreshCart(); return; } catch(e){}
    }
    location.reload();
  }

  // ========== DELEGATED HANDLERS (work across DOM re-renders) ==========

  // Gift addon checkbox toggle
  document.addEventListener('change', function(e){
    var cb = e.target.closest && e.target.closest('[data-gift-toggle]');
    if (!cb) return;
    var addon = cb.closest('[data-gift-addon]');
    if (!addon) return;
    var textarea = addon.querySelector('[data-gift-msg]');
    var msgLine  = addon.querySelector('[data-gift-msgline]');
    addon.classList.toggle('is-active', !!cb.checked);
    if (!cb.checked) {
      // Resolve line key from attribute OR fall back to cart.js lookup by handle
      // (theme cart refresh can leave the addon attribute stale after a save)
      var attrKey = addon.getAttribute('data-line-key');
      function doRemove(key){
        if (!key) return;
        setMsg(msgLine, 'Removing note...', '');
        fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(r){ return r.json(); })
          .then(function(){ setMsg(msgLine, 'Note removed', 'is-ok'); addon.setAttribute('data-line-key',''); refreshDrawer(); })
          .catch(function(){ setMsg(msgLine, 'Could not remove note.', 'is-error'); });
      }
      if (attrKey) {
        doRemove(attrKey);
      } else {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            var giftLine = (cart.items || []).find(function(i){ return i.handle === GIFT_HANDLE; });
            if (giftLine) { doRemove(giftLine.key); }
            else { setMsg(msgLine, 'Note removed', 'is-ok'); }
          });
      }
    } else if (textarea) {
      try { textarea.focus(); } catch(e){}
    }
  });

  // Checkout guard — prevent gift-note-only cart
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.scd__checkout, button[name="checkout"]');
    if (!btn) return;
    // Check cart synchronously via stored window state (cart.js fetch is async; use blocking XHR)
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', false); // synchronous (fast, ~50ms)
    try { xhr.send(); } catch(err){ return; }
    if (xhr.status !== 200) return;
    var cart;
    try { cart = JSON.parse(xhr.responseText); } catch(err){ return; }
    var nonGift = (cart.items || []).filter(function(i){ return i.handle !== GIFT_HANDLE; });
    if (nonGift.length === 0 && cart.items && cart.items.length > 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert('Your cart only contains a Handwritten Gift Note. Please add at least one product before checkout.');
      return false;
    }
  }, true); // capture phase, runs before native checkout submit

  // Gift textarea char counter
  document.addEventListener('input', function(e){
    var ta = e.target.closest && e.target.closest('[data-gift-msg]');
    if (!ta) return;
    var addon = ta.closest('[data-gift-addon]');
    if (!addon) return;
    var counter = addon.querySelector('[data-gift-count]');
    if (counter) counter.textContent = String(ta.value.length);
  });

  // Gift save button
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-gift-save]');
    if (!btn) return;
    var addon = btn.closest('[data-gift-addon]');
    if (!addon) return;
    var textarea = addon.querySelector('[data-gift-msg]');
    var msgLine  = addon.querySelector('[data-gift-msgline]');
    var msg = (textarea && textarea.value || '').trim();
    if (!msg) { setMsg(msgLine, 'Please write a message before saving.', 'is-error'); if (textarea) textarea.focus(); return; }
    btn.disabled = true;
    setMsg(msgLine, 'Saving note...', '');
    var lineKey = addon.getAttribute('data-line-key');
    var addReq = function(){
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(GIFT_VARIANT, 10), quantity: 1, properties: { 'Gift note message': msg } })
      }).then(function(r){ return r.ok ? r.json() : Promise.reject(r.status); });
    };
    var p;
    if (lineKey) {
      p = fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).then(function(r){ return r.json(); }).then(addReq);
    } else {
      p = addReq();
    }
    p.then(function(){
      setMsg(msgLine, 'Note saved.', 'is-ok');
      refreshDrawer();
    }).catch(function(err){
      setMsg(msgLine, 'Could not save note ('+err+'). Try again.', 'is-error');
      btn.disabled = false;
    });
  });

  // Upsell card add button (delegated)
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-upsell-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    var origTxt = btn.textContent;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function(r){ return r.json(); })
      .then(function(){ refreshDrawer(); })
      .catch(function(){ btn.disabled = false; btn.textContent = origTxt; });
  });

  function categoryFor(handle){
    if (!handle) return null;
    if (/coaching-board/i.test(handle)) return 'coaching_board';
    if (/uniform/i.test(handle)) return 'uniform';
    if (/shooting-correction|shot-cube|pure-shot|shoot-master|shooting-aid|palm-aid|shooting-trainer/i.test(handle)) return 'training_aid';
    if (/court/i.test(handle)) return 'court';
    return null;
  }

  function upsellHandlesFor(category){
    switch (category) {
      case 'coaching_board':
        return ['coaching-board-magnet-refill','coaching-board-marker-refill','coach-whistle-lanyard','handwritten-gift-note'];
      case 'uniform':
        return ['team-basketball-socks-3-pack','team-warmup-shirt','customize-basketball-carry-bag-for-6-balls','handwritten-gift-note'];
      case 'training_aid':
        return ['shotdoc-basketball-shooting-trainer','basketball-gripmats','high-school-custom-magnetic-coaching-board-15-7-x-12-6','coach-whistle-lanyard'];
      case 'court':
        return [];
      default:
        return ['handwritten-gift-note'];
    }
  }

  function buildUpsellCard(p){
    var img = (p.featured_image && p.featured_image.src) ? p.featured_image.src : (p.images && p.images[0]) || '';
    var price = (p.variants && p.variants[0] && p.variants[0].price) ? p.variants[0].price : (p.price || '');
    var url = p.url || ('/products/' + p.handle);
    var variantId = (p.variants && p.variants[0] && p.variants[0].id) ? p.variants[0].id : '';
    var priceTxt = (typeof price === 'string') ? price : ('$' + (price/100).toFixed(2));
    var card = document.createElement('div');
    card.className = 'cp-cart__upsell__card';
    var safeTitle = (p.title || '').replace(/</g, '&lt;');
    card.innerHTML =
      '<a href="'+url+'" class="cp-cart__upsell__thumb">'+
        (img ? '<img src="'+img+'&width=240" alt="" loading="lazy">' : '')+
      '</a>'+
      '<div class="cp-cart__upsell__name">'+safeTitle+'</div>'+
      '<div class="cp-cart__upsell__price">'+priceTxt+'</div>'+
      '<button type="button" class="cp-cart__upsell__add" data-upsell-add data-variant-id="'+variantId+'">Add</button>';
    return card;
  }

  function fetchProduct(handle){
    if (UPSELL_CACHE[handle]) return Promise.resolve(UPSELL_CACHE[handle]);
    return fetch('/products/' + handle + '.json', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if (d && d.product) { UPSELL_CACHE[handle] = d.product; return d.product; }
        return null;
      }).catch(function(){ return null; });
  }

  function renderUpsells(){
    var box = $('[data-cp-upsell]');
    var rail = $('[data-cp-upsell-rail]');
    var giftAddon = $('[data-gift-addon][data-hide-when-empty]');
    if (!box || !rail) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var nonGift = (cart.items || []).filter(function(i){ return i.handle !== GIFT_HANDLE; });
        // Hide gift addon entirely if no real items in cart
        if (giftAddon) giftAddon.style.display = nonGift.length > 0 ? '' : 'none';
        // Empty real cart → hide rail too
        if (nonGift.length === 0) { box.hidden = true; return; }
        var cartHandles = (cart.items || []).map(function(i){ return i.handle; });
        var primary = nonGift[0];
        var cat = primary ? categoryFor(primary.handle) : null;
        var candidates = upsellHandlesFor(cat);
        candidates = candidates.filter(function(h){ return cartHandles.indexOf(h) === -1 && h !== GIFT_HANDLE; });
        if (!candidates.length) { box.hidden = true; return; }
        Promise.all(candidates.slice(0, UPSELL_MAX).map(fetchProduct))
          .then(function(prods){
            rail.innerHTML = '';
            var rendered = 0;
            prods.filter(Boolean).forEach(function(p){
              rail.appendChild(buildUpsellCard(p));
              rendered++;
            });
            box.hidden = rendered === 0;
          });
      })
      .catch(function(){ box.hidden = true; });
  }

  // Try to sync the addon checkbox + line key from current cart state.
  // Re-syncs whenever theme re-renders the drawer (cart change).
  function syncGiftFromCart(){
    var addon = $('[data-gift-addon]');
    if (!addon) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var line = (cart.items || []).find(function(i){ return i.handle === GIFT_HANDLE; });
        var cb = addon.querySelector('[data-gift-toggle]');
        var ta = addon.querySelector('[data-gift-msg]');
        var counter = addon.querySelector('[data-gift-count]');
        if (line) {
          addon.setAttribute('data-line-key', line.key);
          addon.classList.add('is-active');
          if (cb) cb.checked = true;
          if (ta && (!ta.value || ta.value === '')) {
            var props = line.properties || {};
            if (props['Gift note message']) ta.value = props['Gift note message'];
          }
          if (counter && ta) counter.textContent = String(ta.value.length);
        } else {
          addon.setAttribute('data-line-key', '');
          addon.classList.remove('is-active');
          if (cb) cb.checked = false;
        }
      })
      .catch(function(){});
  }

  function bindRail(){
    syncGiftFromCart();
    renderUpsells();
  }

  // Subscribe to theme cart events if they exist
  if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
    try {
      window.MinimogEvents.subscribe('ON_OPEN_DRAWER_CART', function(){ setTimeout(bindRail, 150); });
      window.MinimogEvents.subscribe('ON_ITEM_ADDED', function(){ setTimeout(bindRail, 250); });
    } catch(e){}
  }

  // Watch the drawer wrapper for class changes (open/close toggle)
  function watchDrawer(){
    var wrap = $('.scd__wrapper');
    if (!wrap) return;
    var lastHidden = wrap.classList.contains('hidden');
    new MutationObserver(function(){
      var isHidden = wrap.classList.contains('hidden');
      if (lastHidden && !isHidden) { // just opened
        setTimeout(bindRail, 150);
      }
      lastHidden = isHidden;
    }).observe(wrap, { attributes: true, attributeFilter: ['class'] });
  }

  function init(){
    bindRail();
    watchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();